import { useFormikContext } from 'formik'
import { useEffect } from 'react'

export const SetTotalSessionDuration = () => {
  const {
    values: { invoiceEvery, numberOfBillingCycle },
    setFieldValue,
  } = useFormikContext()

  useEffect(() => {
    if (invoiceEvery && numberOfBillingCycle) {
      setFieldValue(
        'totalDurationOfContract',
        `${invoiceEvery * numberOfBillingCycle}`,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceEvery, numberOfBillingCycle])
  return null
}

export const SetTotalSession = () => {
  const {
    values: {
      sessionPerCoachingCycle,
      numberOfCoachingCycle,
      typeOfCoachingCycle,
      totalDurationOfContract,
      // totalSession,
    },
    setFieldValue,
  } = useFormikContext()

  useEffect(() => {
    // Clear totalSession when contract duration is indefinite
    if (!totalDurationOfContract || totalDurationOfContract === 'Indefinite') {
      setFieldValue('totalSession', '')
      setFieldValue('sugTotalSession', '')
      return
    }

    if (
      // !totalSession &&
      totalDurationOfContract &&
      totalDurationOfContract !== 'Indefinite' &&
      sessionPerCoachingCycle &&
      numberOfCoachingCycle &&
      typeOfCoachingCycle
    ) {
      let sessionsPerMonth = 0

      switch (typeOfCoachingCycle) {
        case 'Weekly':
          sessionsPerMonth =
            (4 * sessionPerCoachingCycle) / numberOfCoachingCycle
          break
        case 'Monthly':
          sessionsPerMonth =
            (1 * sessionPerCoachingCycle) / numberOfCoachingCycle
          break
        case 'Yearly':
          sessionsPerMonth =
            sessionPerCoachingCycle / 12 / numberOfCoachingCycle
          break
        default:
          sessionsPerMonth = 0
      }

      const totalSession = Math.round(
        sessionsPerMonth * totalDurationOfContract,
      )

      setFieldValue('sugTotalSession', totalSession)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sessionPerCoachingCycle,
    numberOfCoachingCycle,
    typeOfCoachingCycle,
    totalDurationOfContract,
  ])

  return null
}
